import { UserAnswerType } from '@/tools/types/basic';

const state = () => ({
	userActions: [] as UserAnswerType[]
});

export default state;
